import Splide from '@splidejs/splide';

export function initSplideSlider(sliderElement: HTMLElement, overrideSettings?: any): Splide {
    let settings = {
        type: "loop",
        autoplay: false,
        perPage: 1,
        perMove: 1,
    };

    if (overrideSettings) {
        settings = { ...settings, ...overrideSettings };
    }

    const dataSettings = sliderElement.dataset.splideSettings;
    if (dataSettings && dataSettings !== '' && dataSettings !== '{}') {
        settings = JSON.parse(dataSettings);
    }

    const splide = new Splide(sliderElement, settings);

    splide.mount();

    return splide;
}
